import { useApiQuery } from "app/modules/api-client";
import DurationService, { BasicDurations } from "app/services/DurationService";
import { useDisplayAdvertiserPublisherDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDisplayAdvertiserPublisherDataAndParams";

import type { AdIntelligenceController } from "../../shared/types/types";

export const useAdPlacements = (controller: AdIntelligenceController) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    const { from, to, isWindow } = DurationService.getDurationData(params.duration).forAPI;

    return useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adIntelligenceAdvertiserPlacementsDataList",
            options: {
                enabled: controller === "advertiser",
            },
        },
        {
            country: params.country,
            key: params.key.split(","),
            from,
            to,
            isWindow,
            ...(isWindow ? { latest: BasicDurations.LAST_TWENTY_EIGHT_DAYS } : {}),
        },
    );
};
